module.exports = __webpack_public_path__ + "static/media/success-dt-en.f7c3a66b.png";